// extracted by mini-css-extract-plugin
export default {"root":"InboundPackageTable_root__sti10","tableWrapper":"InboundPackageTable_tableWrapper__le7h0","tableHeader":"InboundPackageTable_tableHeader__589I+"};